import { render, staticRenderFns } from "./rhFssDetail.vue?vue&type=template&id=b7b72a90&"
import script from "./rhFssDetail.vue?vue&type=script&lang=js&"
export * from "./rhFssDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports